import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import Button from "../common/button/button";
import Form from "./geracaoIntegracaoForm";
import Select from "../common/form/select";
import { adicionarReticencias } from "../utils/adicionarReticencias";
import {
    setModoTela,
    initForm,
    salvar,
    excluir,
    setFiltro,
    getLista,
    getListaCliente,
    getListaUnidadeConsumidora,
    getListaGeracaoIntegracaoTipo,
} from "./geracaoIntegracaoActions";
import { Loading } from "../common/loading/loading";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria";
import { LabelSelectUcIconeGestor } from "../common/form/LabelSelectUcIconeGestor";

function GeracaoIntegracao(props) {
    const [state, setState] = useState({
        exibirModalGestorConcessionaria: false,
        itemSelecionado: null,
    });

    //Sem acesso
    if (!props.usuarioLogado || props.usuarioLogado.acesso_cliente) {
        return <div />;
    }

    useEffect(() => {
        props.getListaCliente();
        props.getListaGeracaoIntegracaoTipo();
        props.getListaUnidadeConsumidora();
        props.getLista();
    }, []);

    useEffect(() => {
        props.getLista();
    }, [props.filtro]);

    return (
        <div>
            {props.aguardando ? <Loading /> : null}

            <Content>
                {props.modoTela === "visualizacao" ? <Form visualizar onSubmit={() => {}} /> : null}
                {props.modoTela === "cadastro" ? <Form onSubmit={props.salvar} /> : null}
                {props.modoTela === "exclusao" ? <Form excluir onSubmit={props.excluir} /> : null}
                {props.modoTela === "lista" ? lista() : null}
            </Content>
        </div>
    );

    function formatarDadosAPI(item) {
        //se for solis separa os atributos do JSON para aparecer um em cada campo separado, no Form
        if (item.id_geracao_integracao_tipo == 12) {
            const registro = {
                ...item,
                id_chave_api: item.chave_api && JSON.parse(item.chave_api).KeyId,
                segredo_chave_api: item.chave_api && JSON.parse(item.chave_api).KeySecret,
                url_api: item.chave_api && JSON.parse(item.chave_api).APIURL,
            };
            return registro;
        }
        return item;
    }

    function lista() {
        return (
            <ContentCard>
                <ModalGestorConcessonaria
                    visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_energia}
                    itemSelecionado={state.itemSelecionado}
                    handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
                />
                <ContentCardHeader>
                    <Row>
                        <Grid cols="6 6 4 2">
                            <Button
                                text="Adicionar"
                                type={"success"}
                                icon={"fa fa-plus"}
                                // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/geracaoIntegracao.js (incluir, editar, excluir) e nos endpoints POST, PUT e DELETE /api/geracaoIntegracao
                                disabled={!props.usuarioLogado.acesso_solar_editar}
                                event={() => {
                                    props.setModoTela("cadastro", {});
                                    props.initForm({});
                                }}
                            />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody>
                    <Row>
                        <Select
                            name="id_cliente"
                            options={props.listaCliente.filter((cliente) => props.lista.find((gi) => gi.id_cliente == cliente.id))}
                            label="Cliente"
                            cols="12 6 4"
                            placeholder="Selecione o Cliente"
                            value={props.filtro.id_cliente}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_cliente: value,
                                });
                            }}
                        />
                        <Select
                            name="id_unidade_consumidora"
                            options={props.listaUnidadeConsumidora.filter((uc) => {
                                const filtroCliente = !props.filtro.id_cliente || props.filtro.id_cliente == uc.id_cliente;
                                const estaNaLista = props.lista.find((item) => item.id_unidade_consumidora == uc.id);
                                return filtroCliente && estaNaLista;
                            })}
                            label={
                                <LabelSelectUcIconeGestor
                                    filtro={props.filtro}
                                    listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                                    setExibirModal={(ucFiltro) =>
                                        setState({
                                            ...state,
                                            exibirModalGestorConcessionaria: true,
                                            itemSelecionado: ucFiltro,
                                        })
                                    }
                                />
                            }
                            cols="12 6 4"
                            placeholder="Selecione a UC"
                            value={props.filtro.id_unidade_consumidora}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_unidade_consumidora: value,
                                });
                            }}
                        />
                        <Select
                            name="id_geracao_integracao_tipo"
                            options={props.listaGeracaoIntegracaoTipo.filter((gip) => {
                                const estaNaLista = props.lista.find((item) => item.id_geracao_integracao_tipo == gip.id);
                                return estaNaLista;
                            })}
                            label="Tipo"
                            cols="12 6 4"
                            placeholder="Selecione o tipo"
                            value={props.filtro.id_geracao_integracao_tipo}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_geracao_integracao_tipo: value,
                                });
                            }}
                        />
                    </Row>
                    <Table responsive>
                        <THead>
                            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                <Th sticky>Cliente</Th>
                                <Th sticky>UC</Th>
                                <Th sticky>Tipo</Th>
                                <Th sticky>Usuário</Th>
                                <Th sticky>Senha</Th>
                                <Th sticky>Chave da API</Th>
                                <Th sticky>Link/Nome da instalação</Th>
                            </NewTr>
                        </THead>
                        <TBody>
                            {props.lista.map((item) => {
                                return (
                                    <NewTr
                                        key={item.id}
                                        backgroundColorTr={"#FFFFFF"}
                                        backgroundColorTd={"#F5F5F5"}
                                        botoes={[
                                            {
                                                type: "primary",
                                                icon: "fas fa-eye",
                                                disabled: !props.usuarioLogado.acesso_solar_visualizar,
                                                event: () => {
                                                    const registro = formatarDadosAPI(item);
                                                    props.setModoTela("visualizacao", registro);
                                                    props.initForm(registro);
                                                },
                                            },
                                            {
                                                type: "warning",
                                                icon: "fas fa-pencil-alt",
                                                // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/geracaoIntegracao.js (editar, excluir) e nos endpoints PUT e DELETE /api/geracaoIntegracao
                                                disabled: !props.usuarioLogado.acesso_solar_editar || item.bloquearEdicaoUsuarioImplantacao,
                                                event: () => {
                                                    const registro = formatarDadosAPI(item);
                                                    props.setModoTela("cadastro", registro);
                                                    props.initForm(registro);
                                                },
                                            },
                                            {
                                                type: "danger",
                                                icon: "fas fa-trash-alt",
                                                // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/geracaoIntegracao.js (editar, excluir) e nos endpoints PUT e DELETE /api/geracaoIntegracao
                                                disabled: !props.usuarioLogado.acesso_solar_editar || item.bloquearEdicaoUsuarioImplantacao,
                                                event: () => {
                                                    const registro = formatarDadosAPI(item);
                                                    props.setModoTela("exclusao", registro);
                                                    props.initForm(registro);
                                                },
                                            },
                                        ]}
                                    >
                                        <Td maxWidth={200}>{item.nome_cliente}</Td>
                                        <Td maxWidth={230} paddingRight={10}>
                                            {item.nome_unidade_consumidora}
                                        </Td>
                                        <Td>{item.tipo}</Td>
                                        <Td title={item.usuario}>{adicionarReticencias(item.usuario)}</Td>
                                        <Td>{item.senha}</Td>
                                        <Td maxWidth={200} alignCenter title={item.chave_api}>
                                            {adicionarReticencias(item.chave_api)}
                                        </Td>
                                        <Td maxWidth={200} alignCenter title={item.id_sistema_fotovoltaico}>
                                            {adicionarReticencias(item.id_sistema_fotovoltaico)}
                                        </Td>
                                    </NewTr>
                                );
                            })}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }
}

const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.geracaoIntegracao.modoTela,
    formularioValues: getFormValues("geracaoIntegracaoForm")(state),
    aguardando: state.geracaoIntegracao.aguardando,
    filtro: state.geracaoIntegracao.filtro,
    lista: state.geracaoIntegracao.lista,
    listaCliente: state.geracaoIntegracao.listaCliente,
    listaUnidadeConsumidora: state.geracaoIntegracao.listaUnidadeConsumidora,
    listaGeracaoIntegracaoTipo: state.geracaoIntegracao.listaGeracaoIntegracaoTipo,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            setFiltro,
            salvar,
            excluir,
            getLista,
            getListaCliente,
            getListaUnidadeConsumidora,
            getListaGeracaoIntegracaoTipo,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(GeracaoIntegracao);
